import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-static'

export default ({ authUser }) =>
  authUser && authUser.emailVerified ?
    <ul>
      <li className="menu-title">Dashboard</li>

      <li>
        <Link to="/orders">
          <i className="fas fa-file-invoice-dollar"/> Aufträge
        </Link>
      </li>
      <li>
        <Link to="/clients">
          <i className="fas fa-user-tie"/> Kunden
        </Link>
      </li>
      <li>
        <Link to="/products">
          <i className="fas fa-rainbow"/> Produkte
        </Link>
      </li>
      <li>
        <Link to="/statistics">
          <i className="fas fa-chart-line"/> Statistik
        </Link>
      </li>
      <li className="menu-title">Profil</li>
      <li>
        <Link to="/account">
          <i className="fas fa-cog"/>{' '}
          Konto / Einstellungen
        </Link>
      </li>
      <li>
        <Link to="/signout">
          <i className="fas fa-sign-out-alt"/>{' '}
          Abmelden
        </Link>
      </li>
    </ul>
    :
    <ul>
      <li>
        <Link to="/signin">Anmelden</Link>
      </li>
    </ul>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/Navigation.js